<!-- 4.1 Volume total -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-boxes"></i> Volume total d'envois</h3>
    <span class="periode-info" *ngIf="total">Granularité : {{ total.granularite }}</span>
  </div>
  <div *ngIf="chargement.total" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.total && total">
    <div class="grille-kpi">
      <div class="kpi kpi-primary"><div class="kpi-label">Total envois</div><div class="kpi-valeur">{{ total.totalEnvois }}</div></div>
    </div>
    <div echarts [options]="optTotal" class="chart-container" style="height:280px"></div>
  </ng-container>
</div>

<!-- 4.2 Volume par type de service -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-tags"></i> Volume par type de service</h3>
    <span class="periode-info" *ngIf="parType">{{ parType.totalEnvois }} envois</span>
  </div>
  <div *ngIf="chargement.parType" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <div *ngIf="!chargement.parType && parType" echarts [options]="optParType" class="chart-container" style="height:300px"></div>
</div>

<!-- 4.3 Pics de volumes -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-temperature-high"></i> Pics de volumes</h3>
  </div>
  <div *ngIf="chargement.pics" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.pics && pics">
    <div style="display:grid;grid-template-columns:1.6fr 1fr;gap:18px;">
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Heatmap jour × heure</h4>
        <div echarts [options]="optHeatmap" class="chart-container" style="height:320px"></div>
      </div>
      <div>
        <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Top 10 dates les plus chargées</h4>
        <table class="table-rapport">
          <thead><tr><th>Date</th><th style="text-align:right;">Envois</th></tr></thead>
          <tbody>
            <tr *ngFor="let t of pics.topDates">
              <td>{{ t.date | date:'EEE dd MMM yy' }}</td>
              <td style="text-align:right;font-weight:600;">{{ t.nbEnvois }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>

<!-- 4.4 Évolution des volumes -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-chart-line"></i> Évolution des volumes (vs N-1)</h3>
  </div>
  <div *ngIf="chargement.evolution" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.evolution && evolution">
    <div class="grille-kpi">
      <div class="kpi kpi-success"><div class="kpi-label">Période actuelle</div><div class="kpi-valeur">{{ evolution.totalActuel }}</div></div>
      <div class="kpi"><div class="kpi-label">N-1</div><div class="kpi-valeur">{{ evolution.totalN1 }}</div></div>
      <div class="kpi" [ngClass]="{ 'kpi-success': evolution.variationYoYPct >= 0, 'kpi-danger': evolution.variationYoYPct < 0 }">
        <div class="kpi-label">Variation YoY</div>
        <div class="kpi-valeur">{{ evolution.variationYoYPct > 0 ? '+' : '' }}{{ evolution.variationYoYPct }} %</div>
      </div>
    </div>
    <div echarts [options]="optEvolution" class="chart-container" style="height:280px"></div>
  </ng-container>
</div>

<!-- 4.5 Délais -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-clock"></i> Évolution des délais de livraison</h3>
  </div>
  <div *ngIf="chargement.delais" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.delais && delais">
    <div class="grille-kpi">
      <div class="kpi kpi-primary"><div class="kpi-label">Délai moyen</div><div class="kpi-valeur">{{ delais.delaiMoyenHeures }} h</div></div>
      <div class="kpi"><div class="kpi-label">Médiane</div><div class="kpi-valeur">{{ delais.delaiMedianHeures }} h</div></div>
      <div class="kpi kpi-warn"><div class="kpi-label">P90 (90% rapides que)</div><div class="kpi-valeur">{{ delais.delaiP90Heures }} h</div></div>
      <div class="kpi"><div class="kpi-label">Nb livraisons</div><div class="kpi-valeur">{{ delais.nbLivraisons }}</div></div>
    </div>
    <div echarts [options]="optDelais" class="chart-container" style="height:260px"></div>
  </ng-container>
</div>

<!-- 4.6 Évolution réclamations -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-comment-dots"></i> Évolution des réclamations</h3>
  </div>
  <div *ngIf="chargement.recl" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>
  <ng-container *ngIf="!chargement.recl && recl">
    <div class="grille-kpi">
      <div class="kpi"><div class="kpi-label">Total période</div><div class="kpi-valeur">{{ recl.totalReclamations }}</div></div>
      <div class="kpi" [ngClass]="{ 'kpi-danger': recl.tendancePct > 0, 'kpi-success': recl.tendancePct <= 0 }">
        <div class="kpi-label">Tendance</div>
        <div class="kpi-valeur">{{ recl.tendancePct > 0 ? '↗ +' : '↘ ' }}{{ recl.tendancePct }} %</div>
      </div>
    </div>
    <div echarts [options]="optRecl" class="chart-container" style="height:260px"></div>
  </ng-container>
</div>

<!-- 4.7 Fiabilité partenaires + 4.8 Taux erreurs -->
<div class="carte-rapport">
  <div class="carte-titre">
    <h3><i class="fal fa-handshake"></i> Fiabilité &amp; erreurs des partenaires</h3>
    <div>
      <select [(ngModel)]="typePartenaire" (change)="rechargerPartenaires()" style="height:30px;padding:0 10px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;">
        <option value="LIVREUR">Livreurs</option>
        <option value="CENTRE_TRI_DEPART">Centre de tri (départ)</option>
        <option value="CENTRE_TRI_ARRIVEE">Centre de tri (arrivée)</option>
      </select>
    </div>
  </div>

  <div *ngIf="chargement.fiabilite || chargement.erreursPart" class="chargement-mini"><i class="fal fa-spinner"></i> Chargement…</div>

  <ng-container *ngIf="!chargement.fiabilite && !chargement.erreursPart && fiabilite && erreursPart">
    <div class="grille-kpi">
      <div class="kpi kpi-primary"><div class="kpi-label">Partenaires actifs</div><div class="kpi-valeur">{{ fiabilite.nbPartenaires }}</div></div>
      <div class="kpi kpi-danger"><div class="kpi-label">Taux d'erreurs global</div><div class="kpi-valeur">{{ erreursPart.tauxGlobalPct }} %</div></div>
    </div>

    <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:14px 0 8px;">Classement fiabilité</h4>
    <table class="table-rapport" *ngIf="fiabilite.classement?.length; else videFiabilite">
      <thead>
        <tr>
          <th>Partenaire</th>
          <th style="text-align:right;">Livraisons</th>
          <th style="text-align:right;">Livrées</th>
          <th style="text-align:right;">% Livrées</th>
          <th style="text-align:right;">% Incidents</th>
          <th style="text-align:right;">Note</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of fiabilite.classement">
          <td>{{ p.partenaire }}</td>
          <td style="text-align:right;">{{ p.nbLivraisons }}</td>
          <td style="text-align:right;">{{ p.nbLivrees }}</td>
          <td style="text-align:right;color:#059669;font-weight:600;">{{ p.tauxLivreesPct }} %</td>
          <td style="text-align:right;color:#dc2626;">{{ p.tauxIncidentsPct }} %</td>
          <td style="text-align:right;">{{ p.noteMoyenne != null ? (p.noteMoyenne | number:'1.1-1') + ' ★' : '—' }}</td>
        </tr>
      </tbody>
    </table>
    <ng-template #videFiabilite><div class="vide"><i class="fal fa-inbox"></i> Aucune donnée sur la période</div></ng-template>

    <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:18px 0 8px;">Top partenaires à risque (taux d'erreurs)</h4>
    <table class="table-rapport" *ngIf="erreursPart.classement?.length">
      <thead>
        <tr>
          <th>Partenaire</th>
          <th style="text-align:right;">Livraisons</th>
          <th style="text-align:right;">Erreurs</th>
          <th style="text-align:right;">Taux</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of erreursPart.classement">
          <td>{{ p.partenaire }}</td>
          <td style="text-align:right;">{{ p.nbLivraisons }}</td>
          <td style="text-align:right;color:#dc2626;">{{ p.nbErreurs }}</td>
          <td style="text-align:right;font-weight:600;color:#dc2626;">{{ p.tauxErreurPct }} %</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
